module.exports = __webpack_public_path__ + "static/media/04.45a9372f.png";